import { warn as t } from "../util/warn.js";

var e = function e(_e) {
  void 0 === _e && (_e = {});
  var n = _e.connector;
  return {
    inject: {
      instantSearchInstance: {
        from: "$_ais_instantSearchInstance",
        default: function _default() {
          var t = this.$options._componentTag;
          throw new TypeError('It looks like you forgot to wrap your Algolia search component "<' + t + '>" inside of an "<ais-instant-search>" component.');
        }
      },
      getParentIndex: {
        from: "$_ais_getParentIndex",
        default: function _default() {
          var t = this;
          return function () {
            return t.instantSearchInstance.mainIndex;
          };
        }
      }
    },
    data: function data() {
      return {
        state: null
      };
    },
    created: function created() {
      if ("function" == typeof n) {
        if (this.factory = n(this.updateState, function () {}), this.widget = this.factory(this.widgetParams), this.getParentIndex().addWidgets([this.widget]), this.instantSearchInstance.__initialSearchResults && !this.instantSearchInstance.started) {
          if ("function" != typeof this.instantSearchInstance.__forceRender) throw new Error("You are using server side rendering with <ais-instant-search> instead of <ais-instant-search-ssr>.");

          this.instantSearchInstance.__forceRender(this.widget, this.getParentIndex());
        }
      } else !0 !== n && t("You are using the InstantSearch widget mixin, but didn't provide a connector.\nWhile this is technically possible, and will give you access to the Helper,\nit's not the recommended way of making custom components.\n\nIf you want to disable this message, pass { connector: true } to the mixin.\n\nRead more on using connectors: https://alg.li/vue-custom");
    },
    beforeDestroy: function beforeDestroy() {
      this.widget && this.getParentIndex().removeWidgets([this.widget]);
    },
    watch: {
      widgetParams: {
        handler: function handler(t) {
          this.state = null, this.getParentIndex().removeWidgets([this.widget]), this.widget = this.factory(t), this.getParentIndex().addWidgets([this.widget]);
        },
        deep: !0
      }
    },
    methods: {
      updateState: function updateState(t, e) {
        void 0 === t && (t = {}), e || (this.state = t);
      }
    }
  };
};

export { e as createWidgetMixin };